import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/app/core/components/base.component';
import DownloadHelper from 'src/app/core/helpers/download.helper';
import {
  AboutService,
  AboutTranslationModel,
  FileService,
} from 'src/app/core/services/api-services';
import { MessageService } from 'src/app/core/services/message.service';

@Component({
  selector: 'app-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
})
export class AppFooterComponent extends BaseComponent implements OnInit {
  about$: Observable<AboutTranslationModel> | undefined;

  constructor(
    private readonly aboutService: AboutService,
    private readonly fileService: FileService,
    private readonly messageService: MessageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.about$ = this.aboutService.getTranslationByLanguage();
  }

  pdfExport(fileId: string | undefined): void {
    if (fileId) {
      this.fileService
        .get(fileId)
        .unsubscribeOnDestroy(this)
        .subscribe((file) => {
          DownloadHelper.openFileInNewTab(file);
        });
    } else {
      this.messageService.openErrorTranslation('Documents.NoFileUploaded');
    }
  }
}
